export const LOCALE = "fr_fr"
